/* loaded by smart-asset */
export default require("./none~fggdWnqg.png")